import { render, staticRenderFns } from "./DocumentPreviewer.vue?vue&type=template&id=5161f66e&scoped=true&"
import script from "./DocumentPreviewer.vue?vue&type=script&lang=js&"
export * from "./DocumentPreviewer.vue?vue&type=script&lang=js&"
import style0 from "./DocumentPreviewer.vue?vue&type=style&index=0&id=5161f66e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5161f66e",
  null
  
)

export default component.exports